/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateAutojoinDomainInput = {|
  id: string,
  name?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateAutojoinDomainMutationVariables = {|
  input: UpdateAutojoinDomainInput
|};
export type updateAutojoinDomainMutationResponse = {|
  +updateAutojoinDomain: ?{|
    +AutojoinDomain: ?{|
      +id: string,
      +name: ?string,
    |}
  |}
|};
export type updateAutojoinDomainMutation = {|
  variables: updateAutojoinDomainMutationVariables,
  response: updateAutojoinDomainMutationResponse,
|};
*/


/*
mutation updateAutojoinDomainMutation(
  $input: UpdateAutojoinDomainInput!
) {
  updateAutojoinDomain(input: $input) {
    AutojoinDomain {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateAutojoinDomainInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAutojoinDomainPayload",
    "kind": "LinkedField",
    "name": "updateAutojoinDomain",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AutojoinDomain",
        "kind": "LinkedField",
        "name": "AutojoinDomain",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateAutojoinDomainMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateAutojoinDomainMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateAutojoinDomainMutation",
    "operationKind": "mutation",
    "text": "mutation updateAutojoinDomainMutation(\n  $input: UpdateAutojoinDomainInput!\n) {\n  updateAutojoinDomain(input: $input) {\n    AutojoinDomain {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e6b2c7c7a247b1a20ec02bfcae5d42af';

module.exports = node;
